<template>
  <div class="fixed inset-x-3 top-[max(0.75rem,env(safe-area-inset-top))] z-[9999] flex flex-col gap-2 sm:inset-x-auto sm:top-5 sm:right-5 sm:w-96 sm:gap-3">
    <NotificationToast v-for="toast in toasts" :key="toast.id" :title="toast.title" :message="toast.message" :type="toast.type" :timeout="toast.timeout" @dismiss="removeToast(toast.id)" />
  </div>
</template>
<script setup lang="ts">
import NotificationToast from './NotificationToast.vue'
import { useToast } from '@/composables/useToast'

const { toasts, removeToast } = useToast()
</script>
